<div class="mx-auto w-full md:w-4/5">
  <div class="card card-compact mx-2 mb-8 mt-2 rounded-lg bg-white">
    <div class="card-body">
      <yr-purchases></yr-purchases>
    </div>
  </div>
</div>
